import i18n from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import en from './keys/en.json';
import id from './keys/id-ID.json';
import vi from './keys/vi-VN.json';

i18n
  .use(ICU)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'id-ID': { translation: id },
      'vi-VN': { translation: vi },
    },
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'id-ID', 'vi-VN'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
